import { create } from 'zustand';
import { Report } from '../types';

const INITIAL_REPORT_STATE: Report[] = [
  {
    id: '',
    uId: '',
    name: '',
    note: '',
    status: '',
    files: [
      {
        id: '',
        title: '',
        uploadedBy: '',
        uploadedAt: '',
      },
    ],
  },
];

type FormPageState = {
  isLoading: boolean;
  reports: Report[];
};

type FormPageActions = {
  setIsLoading: (isLoading: boolean) => void;
  setReports: (reports: Report[]) => void;
  reset: () => void;
};

export const useFormPageStore = create<FormPageState & FormPageActions>((set) => ({
  isLoading: true,
  reports: { ...INITIAL_REPORT_STATE },
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setReports: (reports: Report[]) => set({ reports }),
  reset: () => set({ reports: { ...INITIAL_REPORT_STATE }, isLoading: true }),
}));
